import { Component } from "react";
import PropTypes from 'prop-types';

class Block extends Component {}

Block.propTypes = {
  context: PropTypes.shape(),
  block: PropTypes.shape(),
};
Block.defaultProps = {};

export default Block;
